import { Contractors, TabState } from '@interfaces/vendor-management-model';

export const columnDefs = [
  {
    field: 'contractorName',
    headerName: 'Name',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'reportingManager',
    headerName: 'Reporting Manager',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'status',
    headerName: 'Status',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'contractEndDate',
    headerName: 'SOW Expiry',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'primarySkill',
    headerName: 'Primary Skill',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'dateOfJoining',
    headerName: 'DOJ',
    filterParams: { hideMenu: true },
    sortParams: { enabled: false },
  },
  {
    field: 'vendorName',
    headerName: 'Vendor',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'location',
    headerName: 'Location',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'totalExperience',
    headerName: 'Total Exp',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'rto',
    headerName: 'RTO',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
];

export const tabsData: TabState[] = [
  {
    label: 'Org View',
    isTabActive: true,
    value: 'Org View',
    activeTab: true,
  },
  {
    label: 'Manager View',
    isTabActive: false,
    value: 'Manager View',
    activeTab: false,
  },
];

export const StaticTexts = {
  ErrorMessages: {
    NoDataAvailable: 'No data available',
    FailedToFetchManagerData: 'Failed to fetch manager data.',
  },
  Labels: {
    NoDataImageAlt: 'No data found',
    OrgViewTab: 'Org View',
  },
  Alerts: {
    EmployeeIdNotFound: 'Employee ID not found.',
  },
};